import PrimaryCaregiverPage from '../PrimaryCaregiverPage';
import ChildInformationPage from '../ChildInformationPage';
import InsurancePage from '../InsurancePage';
import PrimaryDoctorPage from '../PrimaryDoctorPage';
import SpecialistPage from '../SpecialistPage';
import DiagnosisPage from '../DiagnosisPage';
import AllergyPage from '../AllergyPage';
import SurgeryPage from '../SurgeryPage';
import DietPage from '../DietPage';
import PharmacyPage from '../PharmacyPage';
import MedicationPage from '../MedicationPage';
import SettingsPage from '../SettingsPage';
import NotificationManagement from '../NotificationManagement';
import PDFSettingsPage from '../PDFSettingsPage';
import UserManagement from '../UserManagement';

const getLoggedInRedirect = isAdmin =>
  isAdmin ? adminRoutes[0].route : userRoutes[0].route;

const userRoutes = [
  {
    route: '/primary-caregiver',
    name: 'Primary Caregiver',
    component: PrimaryCaregiverPage,
  },
  {
    route: '/child',
    name: 'Child Information',
    component: ChildInformationPage,
  },
  {
    route: '/insurance',
    name: 'Insurance',
    component: InsurancePage,
  },
  {
    route: '/primary-doctor',
    name: 'Primary Doctor',
    component: PrimaryDoctorPage,
  },
  {
    route: '/specialists',
    name: 'Specialists',
    component: SpecialistPage,
  },
  {
    route: '/diagnosis',
    name: 'Diagnoses',
    component: DiagnosisPage,
  },
  {
    route: '/surgeries',
    name: 'Surgeries',
    component: SurgeryPage,
  },
  {
    route: '/allergies',
    name: 'Allergies',
    component: AllergyPage,
  },
  {
    route: '/diet',
    name: 'Diet',
    component: DietPage,
  },
  {
    route: '/pharmacy',
    name: 'Pharmacy',
    component: PharmacyPage,
  },
  {
    route: '/medications',
    name: 'Medications',
    component: MedicationPage,
  },
  {
    route: '/settings',
    name: 'Settings',
    component: SettingsPage,
  },
  {
    route: '/pdf',
    name: 'Download Care Information',
    component: PDFSettingsPage,
  },
];

const adminRoutes = [
  {
    route: '/notification-management',
    name: 'Notification Management',
    component: NotificationManagement,
  },
  {
    route: '/user-management',
    name: 'User Management',
    component: UserManagement,
  },
];

export { adminRoutes, getLoggedInRedirect, userRoutes };



// WEBPACK FOOTER //
// ./src/modules/App/routes.js